import { Link, useLocation } from "react-router-dom";
import { Home, MessageSquare, CalendarDays, Info, User } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useUnreadMessages } from "@/hooks/useUnreadMessages";
import { Badge } from "@/components/ui/badge";

const NAV_ITEMS = [
  { label: "Home", icon: Home, path: "/" },
  { label: "Messages", icon: MessageSquare, path: "/messages" },
  { label: "Calendar", icon: CalendarDays, path: "/bookings" },
  { label: "General", icon: Info, path: "/general" },
  { label: "Profile", icon: User, path: "/profile" },
] as const;

const MobileBottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();
  const unreadMessages = useUnreadMessages(user);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/" || location.pathname === "/marketplace";
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-t border-border/40 md:hidden">
      <div className="flex items-center justify-around h-12">
        {NAV_ITEMS.map(({ label, icon: Icon, path }) => {
          const active = isActive(path);
          return (
            <Link
              key={path}
              to={path}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full relative transition-colors duration-200 ${
                active ? "text-foreground" : "text-muted-foreground"
              }`}
            >
              <div className="relative">
                <Icon className="h-5 w-5" strokeWidth={active ? 2 : 1.5} />
                {label === "Messages" && unreadMessages > 0 && (
                  <Badge
                    variant="destructive"
                    className="absolute -top-1.5 -right-2.5 h-4 min-w-4 flex items-center justify-center p-0 text-[9px] rounded-full"
                  >
                    {unreadMessages > 9 ? "9+" : unreadMessages}
                  </Badge>
                )}
              </div>
              <span className="text-[10px] font-medium leading-tight">{label}</span>
            </Link>
          );
        })}
      </div>
      {/* Safe area padding for notched phones */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
};

export default MobileBottomNav;
